import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaNt040 {

  // POST parameters
  export namespace Post {
    export interface Request {
      path: {
        noticeId: number
      }
    }

    // API Response
    export type Response = {}
  }

  // API Path
  const pathFormat: string = '/ta/notices/:noticeId/reads'

  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {

    public post<R>(params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler:ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

        const path: string = this.makePath(pathFormat, params.path)

        // 成功時のレスポンス構造サンプル
        const validationSample: Post.Response = {}

        // エラー時のレスポンス構造サンプル
        const validationErrorSample: ResponseError = {
          error: {
            messageId: '',
            message: ''
          }
        }

        // API呼び出し
        return this.callbackWrapper<Post.Response, ResponseError, R>(
          api.post<Post.Response>(path),
          successHandler,
          errorHandler,
          validationSample,
          validationErrorSample
        )
    }
  }
}